import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AuthService } from "../services/authentication/auth.service";

export const AuthGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) {
    auth.logout();
    router.navigate(["/login"]);
    return false;
  }
  return auth.isLoggedIn();
};
